import type { ThreadCategory } from './types'

export const CATEGORY_LABEL: Record<ThreadCategory, string> = {
  commission: 'Commission',
  purchase: 'Purchase',
  collector: 'Collector',
  press: 'Press',
  collaboration: 'Collaboration',
  wholesale: 'Trade',
  support: 'Order',
  personal: 'Personal',
  spam: 'Spam',
  other: 'Message',
}

export function isLead(t: { category: ThreadCategory | null; commissionScore: number | null }) {
  return t.category === 'commission' || (t.commissionScore ?? 0) >= 0.5
}
